module.exports = __webpack_public_path__ + "static/drag_and_drop_form.cde46b34.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/drag_and_drop_form.png
// module id = 218
// module chunks = 193162123475590 216210090109534